import React from 'react'
import { useIntl } from 'react-intl'
import moment from 'moment'
import BodyText from 'LuxKit/Typography/BodyText'
import HelpPane from 'components/Common/HelpPane'
import Modal from 'LuxKit/Modal/Modal'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'

interface Props {
  experience: App.ExperienceOffer
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
}

function ExperienceGiveAsGiftInfoModal(props: Props) {
  const { experience, onSupportEmailClick, onSupportNumberClick } = props

  const intl = useIntl()

  const hasDates = !!(experience.bookByDate || experience.expirationDate)

  const bookByDate = moment(experience.bookByDate ?? experience.expirationDate).format(DMY_CASUAL_FORMAT)
  const travelUntilDate = moment(experience.expirationDate).format(DMY_CASUAL_FORMAT)

  const giftInfoText = hasDates
    ? intl.formatMessage(
        {
          id: 'xOh9qPq56J',
          defaultMessage: 'Buy a package and send as a gift to a special someone. They can book by {bookByDate} and travel until {travelUntilDate}.',
          description: 'Gift info modal description with booking and travel date limits',
        },
        { bookByDate, travelUntilDate },
      )
    : intl.formatMessage({
        id: 'ovFGv47moK',
        defaultMessage: 'Buy a package and send as a gift to a special someone.',
        description: 'Gift info modal description without date limits in the experiences section',
      })

  return (<Modal title={intl.formatMessage({ id: 'Qxls8oZbPB', defaultMessage: 'Gifting available', description: 'Title for gifting information modal on the gift card purchase or redemption page' })}>
    <BodyText className="full-width" variant="large">
      {giftInfoText}
    </BodyText>
    <HelpPane
      onSupportEmailClick={onSupportEmailClick}
      onSupportNumberClick={onSupportNumberClick}
    />
  </Modal>)
}

export default ExperienceGiveAsGiftInfoModal
